import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import Welcome from '../views/Welcome'
import APIDoc from '../views/APIDoc'
import NoPage from '../views/404'
import ShopIndex from '@/views/Shop/index.vue'
import UnitShopIndex from '@/views/Shop/UnitShop.vue'
import SkillShopIndex from '@/views/Shop/SkillShop.vue'
import Layout from "../views/Layout/Layout";
const _import = require('@/router/_import_' + process.env.NODE_ENV)//获取组件的方法

import LoginCallbackView from "../views/LoginCallbackView";

import RankTotal from '@/views/Rank/RankTotal.vue'
import RankMonthly from '@/views/Rank/RankMonthly.vue'
import RankWeekly from '@/views/Rank/RankWeekly.vue'
import RankDaily from '@/views/Rank/RankDaily.vue'

Vue.use(Router)

/* 这里的路由表示没有登录下能打开的界面 */
const createRouter = () => new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/404', component: NoPage, name: 'NoPage',
            meta: {
                title: 'NoPage',
                requireAuth: false,
                NoTabPage: true,
                NoNeedHome: true // 添加该字段，表示不需要home模板
            },
            hidden: true
        },
        {
            path: '/APIDoc', component: APIDoc, name: 'APIDoc',
            meta: {
                title: 'APIDoc',
                requireAuth: false
            },
            hidden: true
        },
        {
            path: '/Welcome',
            component: Welcome,
            name: '首页',
            iconCls: 'fa-home',//图标样式class
            // hidden: true,
            meta: {
                title: '首页',
                requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/',
            component: RankTotal,
            name: '总排行榜',
            iconCls: 'fa-home',//图标样式class
            // hidden: true,
            meta: {
                title: '总排行榜',
                NoTabPage: true,
                requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/Rank/RankMonthly',
            component: RankMonthly,
            name: '月排行榜',
            iconCls: 'fa-home',//图标样式class
            // hidden: true,
            meta: {
                title: '月排行榜',
                NoTabPage: true,
                requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/Rank/RankWeekly',
            component: RankWeekly,
            name: '周排行榜',
            iconCls: 'fa-home',//图标样式class
            // hidden: true,
            meta: {
                title: '周排行榜',
                NoTabPage: true,
                requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/Rank/RankDaily',
            component: RankDaily,
            name: '日排行榜',
            iconCls: 'fa-home',//图标样式class
            // hidden: true,
            meta: {
                title: '日排行榜',
                NoTabPage: true,
                requireAuth: false // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            component: ShopIndex,
            "order": -94,
            "name": "装备",
            "IsHide": false,
            "IsButton": false,
            "path": "/Shop/index",
            "Func": null,
            "meta": {
                "title": "装备",
                "requireAuth": false,
                "NoTabPage": false,
                "keepAlive": false,
                "icon": null
            },
        },
        {
            component: UnitShopIndex,
            "name": "单位",
            "IsHide": false,
            "IsButton": false,
            "path": "/Shop/UnitShop",
            "Func": null,
            "meta": {
                "title": "单位",
                "requireAuth": false,
                "NoTabPage": false,
                "keepAlive": false,
                "icon": null
            },
        },
        {
            component: SkillShopIndex,
            "name": "技能",
            "IsHide": false,
            "IsButton": false,
            "path": "/Shop/SkillShop",
            "Func": null,
            "meta": {
                "title": "技能",
                "requireAuth": false,
                "NoTabPage": false,
                "keepAlive": false,
                "icon": null
            },
        },
        {
          path: "/callback",
          name: "LoginCallbackView",
          component: LoginCallbackView,
          meta: {
              title: '登出',
              NoTabPage: true,
          },
          hidden: true
        },
        {
            path: '*',
            hidden: true,
            redirect: { path: '/404' }
        }
    ]
})

const router = createRouter()

export function filterAsyncRouter(asyncRouterMap) {
    //注意这里的 asyncRouterMap 是一个数组
    const accessedRouters = asyncRouterMap.filter(route => {
        if (route.path && !route.IsButton) {
            if (route.path === '/' || route.path === '-') {//Layout组件特殊处理
                route.component = Layout
            } else {
                try {
                    route.component = _import(route.path.replace('/:id',''))
                } catch (e) {
                    try {
                        route.component = () => import('@/views' + route.path.replace('/:id','') + '.vue');
                    } catch (error) {
                        console.info('%c 当前路由 ' + route.path.replace('/:id','') + '.vue 不存在，因此如法导入组件，请检查接口数据和组件是否匹配，并重新登录，清空缓存!', "color:red")
                    }
                }
            }
        }
        if (route.children && route.children.length && !route.IsButton) {
            route.children = filterAsyncRouter(route.children)
        }
        return true
    })

    return accessedRouters
}

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // the relevant part
}


router.$addRoutes = (params) => {

    var f = item => {
        
        if (item['children']) {
            item['children'] = item['children'].filter(f);
            return true;
        } else if (item['IsButton']) {
            return item['IsButton']===false;
        }  else {
            return true;
        }
        
    }
    
    var params = params.filter(f);

    router.addRoutes(params)
}

export default router;

